import React, { useState } from "react";

const ColorCar = () => {
  const carImages = [
    {
      name: "Black Ash",
      color: "#5c5a5a",
      textColor: "#ffffff",
      image:
        "https://www.mgmotor.co.in/content/dam/mgmotor/vehicles/mg-majestor/images/mg-banner/mgbanner-img-001.png",
    },
    {
      name: "Black Metal",
      color: "#000",
      textColor: "#ffffff",
      image:
        "https://www.mgmotor.co.in/content/dam/mgmotor/vehicles/mg-majestor/images/mg-banner/mgbanner-img-002.png",
    },
    {
      name: "Concrete Grey",
      color: "#595858",
      textColor: "#000000",
      image:
        "https://www.mgmotor.co.in/content/dam/mgmotor/vehicles/mg-majestor/images/mg-banner/mgbanner-img-003.png",
    },
    {
      name: "Pearl White",
      color: "#ffffff",
      textColor: "#000000",
      image:
        "https://www.mgmotor.co.in/content/dam/mgmotor/vehicles/mg-majestor/images/mg-banner/mgbanner-img-004.png",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <section
        className="car-section"
        style={{
          background: carImages[activeIndex].color,
          color: carImages[activeIndex].textColor,
        }}
      >
        <img
          src={carImages[activeIndex].image}
          alt="MG Majestor"
          className="car-image"
        />

        <div
          className="color-name"
          style={{
            background:
              carImages[activeIndex].textColor === "#ffffff"
                ? "#000"
                : "#fff",
            color: carImages[activeIndex].textColor,
          }}
        >
          {carImages[activeIndex].name}
        </div>

        <div className="color-options">
          {carImages.map((item, index) => (
            <button
              key={index}
              className={`color-btn ${
                activeIndex === index ? "active" : ""
              }`}
              style={{ background: item.color }}
              onClick={() => setActiveIndex(index)}
            ></button>
          ))}
        </div>
      </section>

      <style>{`
        .car-section {
          width: 100%;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 40px 20px;
          text-align: center;
          transition: background 0.6s ease, color 0.6s ease;
        }

        .car-image {
          width: 75%;
          max-width: 900px;
          transition: 0.4s ease-in-out;
        }

        .color-name {
          margin-top: 20px;
          padding: 6px 14px;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 500;
          transition: 0.4s ease;
        }

        .color-options {
          margin-top: 20px;
          display: flex;
          gap: 18px;
        }

        .color-btn {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          border: 2px solid #ddd;
          cursor: pointer;
          transition: 0.3s ease;
        }

        .color-btn.active {
          border: 3px solid #fff;
          transform: scale(1.15);
        }

        .color-btn:hover {
          transform: scale(1.1);
        }

        @media (max-width: 991px) {
          .car-image {
            width: 90%;
          }
        }

        @media (max-width: 576px) {
          .car-image {
            width: 100%;
          }

          .color-options {
            gap: 14px;
          }

          .color-btn {
            width: 22px;
            height: 22px;
          }
        }
      `}</style>
    </>
  );
};

export default ColorCar;
